<template>
  <v-container>
    <v-layout wrap>
      <v-flex
        xs12
        sm12
        md3
        xl3>
        <formAdminMonthlyCrossChargeFilter />
      </v-flex>
      <v-flex
        md9
        xl9/>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
